module.exports = __webpack_public_path__ + "img/back.adaf5a94.png";